<p>
  Ако желаете да премахнете дадена обява от платформата <strong>завинаги</strong>, може да я изтриете.
  Изтриването на обява е <strong>необратимо</strong> – тя няма да бъде видима за никого, включително и за вас, и не може
  да бъде възстановена.
</p>
<h6 class="mt-3">Начини за изтриване на обява:</h6>
<ul>
  <li>
    <strong>От страницата на обявата</strong> – Отворете обявата и изберете бутона <strong>„Още действия“</strong>, след
    което натиснете
    <strong>„Изтриване на обявата“</strong>.
  </li>
  <li>
    <strong>От секцията „Моите обяви“</strong> – Навигирайте до <strong>„Профил“ → „Моите обяви“</strong>, намерете
    съответната обява, натиснете бутона с <strong>трите точки (⋮)</strong> и изберете <strong>„Изтриване на обявата“</strong>.
  </li>
</ul>
<h6 class="mt-3">Какво се случва след изтриване?</h6>
<p>
  След като обявата бъде изтрита, тя ще бъде премахната от платформата и няма да може да бъде възстановена. Ако желаете
  само временно да я скриете, използвайте опцията <strong>„Спиране на обявата“</strong> вместо изтриване.
</p>
<div class="alert alert-danger m-0">
  <strong>Важно:</strong> Изтритите обяви не могат да бъдат възстановени. Уверете се, че наистина желаете да я
  премахнете преди да потвърдите действието.
</div>
